import React from 'react';
import { useEmployeeEdit } from '../contexts/EmployeeEditContext';

const EmployeeName = React.memo(function EmployeeName({ id, name, className, style, onSaved }) {
  const ctx = useEmployeeEdit();

  if (!ctx || !id) {
    return <span className={className} style={style}>{name}</span>;
  }

  return (
    <span
      className={className}
      style={{ cursor: 'pointer', ...style }}
      onDoubleClick={() => ctx.openEdit(id, { onSaved })}
      title="ดับเบิ้ลคลิกเพื่อแก้ไข"
    >
      {name}
    </span>
  );
});

export default EmployeeName;
